import { makeStyles } from "@material-ui/core/styles";

export const reportingStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
  },
  rightMargin: {
    marginTop: -5, // this accounts for the helper text
    marginRight: theme.shape.padding,
  },
  topMargin: {
    marginTop: -5, // this accounts for the helper text
  },
  wordButtons: {
    marginTop: 25,
  },
  iconButtons: {
    display: "flex",
    alignItems: "center",
    height: 44,
    marginTop: 20,
  },
  actionButtonWrap: {
    display: "flex",
  },
  iconButtonWrap: {
    width: 88,
  },
  paper: {
    display: "flex",
    alignItems: "flex-start",
    padding: `${theme.shape.padding}px`,
  },
  fieldWidth: {
    minWidth: "150px",
  },
  operatorWidth: {
    minWidth: "150px",
  },
  valueWidth: {
    minWidth: "150px",
  },
}));

export const allowlistStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
  },
  rightMargin: {
    marginTop: -5, // this accounts for the helper text
    marginRight: theme.shape.padding,
  },
  topMargin: {
    marginTop: -5, // this accounts for the helper text
  },
  wordButtons: {
    marginTop: 25,
  },
  iconButtons: {
    display: "flex",
    alignItems: "center",
    height: 44,
    marginTop: 20,
  },
  actionButtonWrap: {
    display: "flex",
  },
  iconButtonWrap: {
    width: 88,
  },
  paper: {
    display: "flex",
    alignItems: "flex-start",
    padding: `${theme.shape.padding}px 0`,
  },
  selectFieldWrapper: {
    width: "25%",
  },
  valueFieldWrapper: {
    width: "50%",
  },
  fieldWidth: {
    width: "97%",
  },
  operatorWidth: {
    width: "97%",
  },
  valueWidth: {
    width: "100%",
  },
}));
